import { Dialog } from '@ori-ui/components';
import type { FC } from 'react';

import { useAppContext } from '../../contexts';
import { Loading } from '../Loading';
import { NotifyCumulus } from '../NotifyCumulus';

export const NotifyPopup: FC = () => {
  const { close, loading, open } = useAppContext();

  return (
    <Dialog
      open={open}
      onClose={close}
    >
      {loading ? <Loading /> : <NotifyCumulus />}
    </Dialog>
  );
};
